import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { CartProvider } from '@/contexts/CartContext';
import { AppShell } from '@/components/app-shell';

// Public Pages
import {
  LandingPage,
  PricingPage,
  FeaturesPage,
  SolutionsPage,
  DocsPage,
  SecurityPage,
  TermsPage,
  PrivacyPage,
} from '@/pages/public';

// Auth Pages
import { LoginPage, SignupPage, ForgotPasswordPage } from '@/pages/auth';

// App Pages
import {
  DashboardPage,
  InboxPage,
  POSPage,
  ProductsPage,
  InventoryPage,
  OrdersPage,
  CustomersPage,
  InvoicesPage,
  PaymentsPage,
  ReportsPage,
  AutomationsPage,
  SettingsPage,
  AdminPage,
} from '@/pages/app';

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="sparkcommerce-theme">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/solutions" element={<SolutionsPage />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />

              {/* Auth Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />

              {/* App Routes (Protected) */}
              <Route path="/app" element={<AppShell />}>
                <Route index element={<DashboardPage />} />
                <Route path="inbox" element={<InboxPage />} />
                <Route path="pos" element={<POSPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="inventory" element={<InventoryPage />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="customers" element={<CustomersPage />} />
                <Route path="invoices" element={<InvoicesPage />} />
                <Route path="payments" element={<PaymentsPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="automations" element={<AutomationsPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin" element={<AppShell />}>
                <Route index element={<AdminPage />} />
              </Route>

              {/* Dashboard redirect */}
              <Route path="/dashboard" element={<Navigate to="/app" replace />} />

              {/* Catch-all redirect */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
